
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ContactDetailsDialog extends Common.GridEditorDialog<ContactDetailsRow> {
        protected getFormKey() { return ContactDetailsForm.formKey; }
        //protected getIdProperty() { return ContactDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return ContactDetailsRow.localTextPrefix; }
        protected getNameProperty() { return ContactDetailsRow.nameProperty; }
        //protected getService() { return ContactDetailsService.baseUrl; }
        //protected getDeletePermission() { return ContactDetailsRow.deletePermission; }
        //protected getInsertPermission() { return ContactDetailsRow.insertPermission; }
        //protected getUpdatePermission() { return ContactDetailsRow.updatePermission; }

        protected form = new ContactDetailsForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.MobileNo);
            q.setTextRightAlign(this.form.Phone);
            q.showAndSetRequiredField(this.form.MobileNo);
            q.showAndSetRequiredField(this.form.Phone);

            this.form.MobileNo.changeSelect2(e => {
                if (this.form.MobileNo.value != "") {
                    q.showAndEnableField(this.form.Phone);
                    if (!isNumeric(this.form.MobileNo.value)) {
                        Q.alert('Invalid Mobile No');
                        this.form.MobileNo.value = "";

                        return;
                    }
                } else
                    q.showAndSetRequiredField(this.form.Phone);

            });
            this.form.Phone.changeSelect2(e => {
                var phone = this.form.Phone.value;
                if (this.form.Phone.value != "") {
                    q.showAndEnableField(this.form.MobileNo);

                    if (!isNumeric(this.form.Phone.value)) {
                        Q.alert('Invalid Phone No');
                        this.form.Phone.value = "";
                        return;
                    }
                } else
                    q.showAndSetRequiredField(this.form.MobileNo);

            });
            function isNumeric(value) {
                return /^-?\d+$/.test(value);
            }
            this.form.AddtoZiFlow.changeSelect2(e => {
                var addtoziflow = this.form.AddtoZiFlow.value;
                if (addtoziflow == "1") {
                    q.showAndEnableField(this.form.Comment);
                    q.showAndEnableField(this.form.Decision);
                    q.showAndEnableField(this.form.Manage);
                    q.showAndEnableField(this.form.Share);
                }
                if (addtoziflow == "0") {
                    q.hideField(this.form.Comment);
                    q.hideField(this.form.Decision);
                    q.hideField(this.form.Manage);
                    q.hideField(this.form.Share);
                }
            })
        }
    }
}